import { render, staticRenderFns } from "./FcsMcaInformationTable.vue?vue&type=template&id=70fa882a&scoped=true&"
import script from "./FcsMcaInformationTable.vue?vue&type=script&lang=js&"
export * from "./FcsMcaInformationTable.vue?vue&type=script&lang=js&"
import style0 from "./FcsMcaInformationTable.vue?vue&type=style&index=0&id=70fa882a&scoped=true&lang=css&"
import style1 from "./FcsMcaInformationTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa882a",
  null
  
)

export default component.exports